import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "w-full flex flex-wrap py-3" }
const _hoisted_2 = {
  key: 0,
  class: "px-4"
}

import { PropType, ref } from 'vue';
import ParticipantVue from './Participant.vue';
import { v4 } from 'uuid';
import { Participant } from '@/typings/wrestler';


export default /*#__PURE__*/_defineComponent({
  props: {
  participants: {
    type: Array as PropType<Array<Participant>>,
    default: () => [],
  },
},
  setup(__props) {

const uuid = ref(v4());



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.participants, (participant, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "flex items-center",
        key: `${uuid.value}_${index}`
      }, [
        _createVNode(ParticipantVue, { participant: participant }, null, 8, ["participant"]),
        (index < __props.participants.length - 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, "vs"))
          : _createCommentVNode("", true)
      ]))
    }), 128))
  ]))
}
}

})